import {ReactNode, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {Container} from '@yosmanyga/rich-ui';
import {Restoration, RestorationHelp} from '@yosmanyga/fortaleza-core';
import {BlankLayout} from "../BlankLayout.tsx";

const RestorationScreen = () => {
    const navigate = useNavigate();

    const Layout = useCallback(({
        basic,
        list,
        action,
        ...props
    }: {
        basic?: boolean;
        list?: ReactNode;
        action?: ReactNode;
    }) => {
        return <BlankLayout
            templates={{
                help: () => {
                    return <RestorationHelp
                        templates={{
                            layout: Container,
                        }}
                    />
                },
                footer: () => {
                    return <Container
                        margin={{
                            top: 1,
                            bottom: 1
                        }}
                    >
                        {action}
                    </Container>
                }
            }}
            onBack={() => {
                navigate(-1);
            }}
            {...props}
        >
            {list}
        </BlankLayout>
    }, []);

    const handleOnRestore = useCallback(() => {
        navigate('/');
    }, []);

    return <Restoration
        templates={{
            layout: Layout,
        }}
        inverted={false}
        onRestore={handleOnRestore}
    />
};

export {RestorationScreen};
